// extracted by mini-css-extract-plugin
export default {"my_select_wrapper":"MySelect_my_select_wrapper__C5H+4","my_select":"MySelect_my_select__IhecQ","label":"MySelect_label__w6zug"};